export enum EFormFieldExam {
  SubclinicalDiagnosis = 'subclinical_diagnosis',
  Solution = 'solution',
  Diagnosis = 'diagnosis',
  UserBio = 'user_bio',
  MedicalHistory = 'medical_history',
  ReasonForVisit = 'reason_for_visit',
  Premise = 'premise',
  Lympho = 'lympho',
  LymphoNote = 'lympho_note',
  MucosaColor = 'mucosa_color',
  MucosaColorNote = 'mucosa_color_note',
  PhysicalCondition = 'physical_condition',
  PhysicalConditionNote = 'physical_condition_note',
  Hearth = 'hearth',
  HearthNote = 'hearth_note',
  Kidney = 'kidney',
  KidneyNote = 'kidney_note',
  Lung = 'lung',
  LungNote = 'lung_note',
  Nerve = 'nerve',
  NerveNote = 'nerve_note',
  Stomatch = 'stomatch',
  StomatchNote = 'stomatch_note',
  OtherOrgan = 'other_organ'
}
